import { motion } from "framer-motion";
import { Users, Wrench, Sparkles, Hammer, Percent } from "lucide-react";

const perks = [
  { icon: Sparkles, label: "Professional Cleaners" },
  { icon: Hammer, label: "Trusted Handymen" },
  { icon: Wrench, label: "Specialty Organizers" },
  { icon: Percent, label: "Family Rate Discounts" },
];

export const ClientForLife = () => (
  <section className="bg-ink py-12 md:py-16">
    <div className="container">
      <div className="mx-auto max-w-5xl">
        <div className="grid items-center gap-12 lg:grid-cols-2">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <p className="mb-3 text-sm font-semibold uppercase tracking-[0.3em] text-gold">Client for Life</p>
            <h2 className="font-display text-5xl tracking-wide text-white md:text-6xl">
              More Than Just<br />
              <span className="text-gradient-gold">a Cleanout</span>
            </h2>
            <p className="mt-6 text-lg leading-relaxed text-white/80">
              When you work with Garage Kings YEG, you aren't just a customer; you're part of our network.
              Our clients receive exclusive, lifetime access to our preferred vendor list. Need a professional
              cleaner, a handyman, or a specialized organizer? Our partners offer discounted{" "}
              <span className="font-semibold text-gold">"Family Rates"</span> specifically for Garage Kings
              clients — even years after your project is done.
            </p>
            <p className="mt-4 font-display text-2xl tracking-wide text-gold">We take care of our own.</p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="absolute -inset-4 rounded-3xl bg-gold/10 blur-2xl" />
            <div className="relative rounded-2xl border-2 border-gold/30 bg-navy p-6 shadow-elevated sm:p-8">
              <div className="mb-6 flex items-center gap-3">
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-gold">
                  <Users className="h-6 w-6 text-ink" />
                </div>
                <div>
                  <div className="font-display text-2xl tracking-wide text-white">Lifetime Network</div>
                  <div className="text-xs uppercase tracking-widest text-gold">Member benefits</div>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-3">
                {perks.map((p) => (
                  <div
                    key={p.label}
                    className="flex flex-col items-center gap-2 rounded-xl border border-white/10 bg-white/5 p-4 text-center"
                  >
                    <p.icon className="h-6 w-6 text-gold" />
                    <span className="text-sm font-semibold text-white">{p.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  </section>
);
